// load video dau trang
jQuery(document).ready(function () {
    var $video = jQuery('#intro-video-overlay .intro-video');
    var $overlay = jQuery('#intro-video-overlay');
    if ($video.length && $overlay.length) {
        $video.on('ended', function() {
            $overlay.addClass('hidden');
        });
        $video.on('error', function() {
            $overlay.addClass('hidden');
        });
        setTimeout(function() {
            if (!$overlay.hasClass('hidden')) {
                $overlay.addClass('hidden');
            }
        }, 10000);
    }
});
// count number
jQuery(document).ready(function () {
  function animateCounter($el, target) {
    jQuery({ countNum: 0 }).animate(
      { countNum: target },
      {
        duration: 2000,
        easing: 'swing',
        step: function() {
          $el.text(Math.floor(this.countNum).toLocaleString("de-DE"));
        },
        complete: function() {
          $el.text(this.countNum.toLocaleString("de-DE"));
        }
      }
    );
  }
  function startCounters() {
    jQuery('.counter').each(function(){
      var $this = jQuery(this);
      var target = parseInt($this.data('target'));
      if(!$this.hasClass('counted') && jQuery(window).scrollTop() + jQuery(window).height() > $this.offset().top){
        animateCounter($this, target);
        $this.addClass('counted');
      }
    });
  }
  jQuery(window).on('scroll', startCounters);
  startCounters();
});